import { inject } from '@angular/core';
import { injectTranslation, RoutingService } from '@skylab-angular-shared/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { KsefReceivedDocumentKind, PurchaseDocumentKind } from '@skylab-shared/dataModel';
import { DocumentsRouting } from './documents-routing';

export const createPurchaseDocumentFromEInvoice = (entity: {id: number; ksefDocumentKind: KsefReceivedDocumentKind, kind: PurchaseDocumentKind}) => {
    const toastService = inject(ToastService);
    const routingService = inject(RoutingService);
    const _T = injectTranslation();

    if ((entity.ksefDocumentKind !== KsefReceivedDocumentKind.Invoice) && entity.kind === PurchaseDocumentKind.PurchaseInvoice) {
        toastService.showAsync({
            text: _T('scenes.e-invoices-received.actions.create-purchase-invoice.invoice-only'),
            type: 'error'
        });
        return;
    }
    routingService.navigate([DocumentsRouting.getCreateState(entity.kind).url], { queryParams: { ePurchaseInvoiceId: entity.id } })
}